<div class="mr-5 p-5 bg-white w-full">
    <form [formGroup]="formAcuerdo">
        <div class="flex pb-0 items-baseline">
            <mat-form-field class="w-1/2">
                <mat-label>Acuerdo</mat-label>
                <mat-select formControlName="acuerdo">
                    @for (item of catAcuerdos; track item.idFE) {
                        <mat-option [value]="item.idFE">{{item.fechaAcuerdo.substr(0,10).split("-").reverse().join("-")}}</mat-option>
                    }
                </mat-select>
                @if(formAcuerdo.controls["acuerdo"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <button mat-mini-fab color="primary" class="m-2" (click)="fnAlta('acuerdo')" [disabled]="deshabilitado"><mat-icon>add</mat-icon></button>
            <mat-form-field class="w-1/2">
                <mat-label>Tema</mat-label>
                <mat-select formControlName="tema">
                    @for (item of catTemas; track item.id) {
                        <mat-option [value]="item.id">{{item.nombreTema}}</mat-option>
                    }
                </mat-select>
                @if(formAcuerdo.controls["tema"].hasError('required')) {
                    <mat-error>Campo obligatorio.</mat-error>
                }
            </mat-form-field>
            <button mat-mini-fab color="primary" class="ml-2 mr-5" (click)="fnAlta('tema')" [disabled]="deshabilitado || (formAcuerdo.controls['acuerdo'].value == '')"><mat-icon>add</mat-icon></button>
        </div>
        @if(tipoFormAlta == "" && fnTemaConfidencial() == false) {
            <div class="flex flex-col pb-5">
                <label class="label-descripcion">Descripción<span class="obligatorio">*</span></label>
                <div class="NgxEditor__Wrapper w-full min-h-72 mr-5">
                    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar" [disabled]="deshabilitado"></ngx-editor-menu>
                    <ngx-editor [editor]="editor" formControlName="descripcion_tema" [placeholder]="''"></ngx-editor>
                </div>
            </div>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Tipo de tema</mat-label>
                    <mat-select formControlName="tipo_tema">
                        @for (item of catTipoTema; track item.id) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["tipo_tema"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <div class="w-1/3 mb-5 mr-5 flex justify-center justify-items-center items-center">
                    <mat-slide-toggle formControlName="confidencial" color="primary" class="mr-5">Confidencial</mat-slide-toggle>
                </div>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Categorización</mat-label>
                    <mat-select formControlName="id_categorizacion">
                        @for (item of catCategorizacion; track item.id) {
                            <mat-option [value]="item.id" [disabled]="fnCategorizacion(formAcuerdo.get('confidencial')?.value, item.id) || !oUsuario.escritura.includes(item.id)">{{item.descripcionCompleta}}</mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["id_categorizacion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Categoria</mat-label>
                    <mat-select formControlName="id_categoria">
                        <mat-select-trigger>
                            <span class="bullet color-{{obtenerCategoria(formAcuerdo.controls['id_categoria'].value, 'color')}}"></span> 
                            {{ obtenerCategoria(formAcuerdo.controls["id_categoria"].value, 'descripcion') }}
                        </mat-select-trigger>
                        @for (item of catCategoria; track item.id) {
                            <mat-option [value]="item.id"> <span class="bullet color-{{item.id}}"></span> {{item.descripcion}}</mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["id_categoria"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <div class="w-1/3 mr-5"></div>
                <div class="w-1/3 mr-5"></div>
            </div>
            <p>Responsables del tema</p>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Analista</mat-label>
                    <mat-select formControlName="analista">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 1) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["analista"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Supervisor</mat-label>
                    <mat-select formControlName="supervisor">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 2) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["supervisor"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Coordinador</mat-label>
                    <mat-select formControlName="coordinador">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 3) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdo.controls["coordinador"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @if(fnTemaConfidencial()) {
            <div ng-show="" style="margin: 15px 0px;">
                <span class="md-headline" style="display:block">TEMA CONFIDENCIAL</span>
                <span class="md-subhead">Lo sentimos, usted no tiene permiso para visualizar este tema.</span>
            </div>
        }
    </form>
    @if(tipoFormAlta != "") {
        <form [formGroup]="formAcuerdoNuevo">
            <h2>Nuevo Acuerdo</h2>
            <div class="flex pb-0">
                @if(tipoFormAlta == "acuerdo") {
                    <mat-form-field class="w-1/2 mr-5">
                        <mat-label>Fecha del acuerdo</mat-label>
                        <input matInput [matDatepicker]="picker1" [min]="today" formControlName="acuerdo">
                        <!-- <mat-hint>DD/MM/YYYY</mat-hint> -->
                        <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                        @if(formAcuerdoNuevo.controls["acuerdo"].hasError('required')) {
                            <mat-error>Campo obligatorio.</mat-error>       
                        } 
                    </mat-form-field>
                }
                <mat-form-field class="w-1/2 mr-5">
                    <mat-label>Tema</mat-label>
                    <input type="text" matInput formControlName="tema">
                    @if(formAcuerdoNuevo.controls["tema"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex flex-col pb-5">
                <label class="label-descripcion">Descripción<span class="obligatorio">*</span></label>
                <div class="NgxEditor__Wrapper w-full min-h-72 mr-5">
                    <ngx-editor-menu [editor]="editor_alta" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="editor_alta" formControlName="descripcion_tema" [placeholder]="''"></ngx-editor>
                </div>
            </div>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Tipo de tema</mat-label>
                    <mat-select formControlName="tipo_tema">
                        @for (item of catTipoTema; track item.id) {
                            <mat-option [value]="item.id">{{item.descripcion}}</mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["tipo_tema"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <div class="w-1/3 mb-5 mr-5 flex justify-center justify-items-center items-center">
                    <mat-slide-toggle formControlName="confidencial" color="primary" class="mr-5">Confidencial</mat-slide-toggle>
                </div>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Categorización</mat-label>
                    <mat-select formControlName="id_categorizacion">
                        @for (item of catCategorizacion; track item.id) {
                            <mat-option [value]="item.id"
                            [disabled]="fnCategorizacion(formAcuerdoNuevo.get('confidencial')?.value, item.id) || !oUsuario.escritura.includes(item.id)"
                            >
                                {{item.descripcionCompleta}}
                            </mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["id_categorizacion"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Categoria</mat-label>
                    <mat-select formControlName="id_categoria">
                        <mat-select-trigger>
                            <span class="bullet color-{{obtenerCategoria(formAcuerdoNuevo.controls['id_categoria'].value, 'color')}}"></span> 
                            {{ obtenerCategoria(formAcuerdoNuevo.controls["id_categoria"].value, 'descripcion') }}
                        </mat-select-trigger>
                        @for (item of catCategoria; track item.id) {
                            <mat-option [value]="item.id"> <span class="bullet color-{{item.id}}"></span> {{item.descripcion}}</mat-option>
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["id_categoria"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <div class="w-1/3 mr-5"></div>
                <div class="w-1/3 mr-5"></div>
            </div>
            <p>Responsables del tema</p>
            <div class="flex pb-0">
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Analista</mat-label>
                    <mat-select formControlName="analista">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 1) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["analista"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Supervisor</mat-label>
                    <mat-select formControlName="supervisor">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 2) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["supervisor"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
                <mat-form-field class="w-1/3 mr-5">
                    <mat-label>Coordinador</mat-label>
                    <mat-select formControlName="coordinador">
                        @for (item of catUsuarios; track item.id) {
                            @if(item.activo && item.mostrar && item.rol === 3) {
                                <mat-option [value]="item.id">{{item.nombre}}</mat-option>
                            }
                        }
                    </mat-select>
                    @if(formAcuerdoNuevo.controls["coordinador"].hasError('required')) {
                        <mat-error>Campo obligatorio.</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="flex pb-0 justify-end">
                <button mat-stroked-button color="primary" (click)="fnCancelar()" class="mr-1">CANCELAR</button>
                <button mat-flat-button color="primary" (click)="fnGuardarNuevo()" class="mr-5" [disabled]="formAcuerdoNuevo.invalid">GUARDAR</button>
            </div>
        </form>
    }
</div>